import { validatePhoneNumber } from "../../utils/utility";
import React from "react";
import RenderModalForm from "./renderModalForm";
import { Form, notification } from "antd";
import { useMutation } from "@tanstack/react-query";

const EditAccount = ({
  modalOpen,
  setModalOpen,
  disabled = true,
  formEdit,
  func,
  formAdding = false,
  handleSuccess = () => { },
  roleManagement = []
}) => {
  const checkChangePassword = Form.useWatch('change_password', formEdit);
  const avatar = Form.useWatch('avatar', formEdit);

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: func,
    onSuccess: (data) => {
      notification.success({ message: formAdding ? 'Tạo thông tin tài khoản thành công!' : 'Cập nhật thông tin tài khoản thành công!' });
      setModalOpen(false);
      handleSuccess();
    },
    onError: error => {
      notification.error({ message: error.data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!' });
    }
  })

  const fields = [
    {
      name: 'id',
      colClass: 'hidden',
    },
    {
      name: 'avatar',
      label: 'Ảnh đại diện',
      type: 'upload-cdn',
      lg: 24,
      propsInput: {
        listType: 'picture-card',
        className: 'custom',
      },
      icon: !avatar?.length ? (
        <button className="w-24 h-24" type="button">
          Tải lên
        </button>
      ) : null,
    },
    {
      name: 'first_name',
      label: 'Họ',
      rules: [{ required: true }],
      lg: 12,
    },
    {
      name: 'last_name',
      label: 'Tên',
      rules: [{ required: true }],
      lg: 12,
    },
    {
      name: 'username',
      label: 'Tên đăng nhập',
      propsInput: { disabled: !formAdding },
      rules: [{ required: true }],
      lg: 12,
    },
    {
      name: 'job',
      label: 'Vị trí',
      propsInput: { disabled },
      lg: 12,
    },
    {
      name: 'email',
      label: 'Email',
      rules: [{ type: 'email', message: 'Email không hợp lệ. Vui lòng nhập lại!' }],
      lg: 12,
    },
    {
      name: 'phone',
      label: 'Số điện thoại',
      lg: 12,
      rules: [
        () => ({
          validator(_, value) {
            if (value && !validatePhoneNumber(value)) {
              return Promise.reject(new Error('Số điện thoại không hợp lệ. Vui lòng nhập lại!'));
            }
            return Promise.resolve();
          },
        }),
      ],
    },
    {
      name: 'birthday',
      label: 'Ngày sinh',
      type: 'date',
      lg: 12,
    },
    {
      name: 'role',
      label: 'Phân quyền',
      type: 'select',
      rules: [{ required: true }],
      colClass: disabled ? 'hidden' : '',
      lg: 12,
      options: (Array.isArray(roleManagement) ? roleManagement : roleManagement?.roles || roleManagement?.data || []).map(
        (item) => ({ value: item.id, label: item.name })
      ),
    },
    {
      name: 'staff_id_lichviet',
      label: 'ID Lịch Việt CMS (cũ)',
      type: 'number',
      lg: 12,
      propsInput: { placeholder: 'Nhập ID user bên lichviet_cms cũ' },
    },
    {
      name: 'is_active',
      label: 'Trạng thái',
      type: 'select',
      rules: [{ required: true }],
      lg: 12,
      options: [
        { value: 1, label: 'Đã kích hoạt' },
        { value: 0, label: 'Chờ kích hoạt' },
      ],
    },
    {
      name: 'change_password',
      label: '',
      labelCheckbox: 'Thay đổi mật khẩu',
      type: 'checkbox',
      lg: 24,
      colClass: formAdding ? 'hidden' : '',
    },
    {
      name: 'password',
      label: !disabled ? 'Mật khẩu' : 'Mật khẩu cũ',
      type: 'password',
      colClass: checkChangePassword || disabled || formAdding ? '' : 'hidden',
      propsInput: { autoComplete: 'new-password' },
      rules: [{ required: checkChangePassword || disabled || formAdding }],
      lg: 12,
    },
    {
      name: 'new_password',
      label: 'Mật khẩu mới',
      type: 'password',
      colClass: checkChangePassword && disabled ? '' : 'hidden',
      rules: [{ required: checkChangePassword && disabled }],
      lg: 12,
    },
  ];
  const onSubmitUpdate = (data) => {
    const checkUploading = data.avatar?.some(i => i.status === 'uploading');
    if (checkUploading) {
      notification.warning({ message: 'File đang được upload vui lòng chờ trong giây lát!' });
      return;
    }
    mutate({
      ...data,
      birthday: data.birthday && data.birthday.format('YYYY-MM-DD'),
      avatar: data.avatar?.[0]?.response
    })
  }
  return (
    <>
      <RenderModalForm
        loadingSubmit={isLoading}
        handleCloseModal={() => setModalOpen(false)}
        modalTitle={formAdding ? 'Tạo mới tài khoản' : 'Cập nhật thông tin tài khoản'}
        modalWidth={700}
        isOpenModal={modalOpen}
        onFinish={onSubmitUpdate}
        fields={fields}
        form={formEdit}
      />
    </>
  )
}

export default EditAccount;
